<div class="content">
  <h1>{{ title }}</h1>

  <div class="wysiwyg" [innerHtml]="body"></div>
</div>

<div
  *ngFor="let c of content; let i = index"
  class="content content--{{ c.type }}"
  [class.content--odd]="i % 2"
>
  <ng-container *ngIf="c.type === ContentType.TEXT">
    <div class="wysiwyg" [innerHtml]="c.text"></div>
  </ng-container>

  <ng-container *ngIf="c.type === ContentType.IMAGE">
    <div class="image">
      <img
        [src]="c.url"
        [title]="c.title"
        [alt]="c.alt"
        [style.backgroundImage]="'url(' + c.blur + ')'"
      />
    </div>
  </ng-container>

  <ng-container *ngIf="c.type === ContentType.IMAGETEXT">
    <div
      class="wysiwyg"
      [class.wysiwyg--wide]="c.standing"
      [innerHtml]="c.text"
    ></div>

    <div class="image" [class.image--standing]="c.standing">
      <img
        [src]="c.url"
        [title]="c.title"
        [alt]="c.alt"
        [style.backgroundImage]="'url(' + c.blur + ')'"
      />
    </div>
  </ng-container>

  <ng-container *ngIf="c.type === ContentType.GALLERY">
    <ul class="gallery">
      <li *ngFor="let img of c.images" class="gallery__item">
        <img
          class="gallery__img"
          [src]="img.url"
          [title]="img.title"
          [alt]="img.alt"
          [style.backgroundImage]="'url(' + img.blur + ')'"
        />
      </li>
    </ul>
  </ng-container>
</div>
